import {
  SET_CHANHGED_SHUTDOWN_FILTER,
  SET_VISIBLE_SHUTDOWN_FILTER,
  SET_CHOSEN_SHUTDOWN_FILTER,
  SET_SHUTDOWN_FILTER_VALUES,
  RESET_SHUTDOWN_FILTER_VALUES,
  SET_SEARCH_VALUE_SHUTDOWN_FILTER,
  SET_VALUE_NEW_SHUTDOWN,
} from './types';

export const setVisibleShutdownFilter = (payload) => ({
  type: SET_VISIBLE_SHUTDOWN_FILTER,
  payload,
});

export const setChangedShutdownFilter = (payload) => ({
  type: SET_CHANHGED_SHUTDOWN_FILTER,
  payload,
});

export const setChosenShutdownFilter = (payload) => ({
  type: SET_CHOSEN_SHUTDOWN_FILTER,
  payload,
});

export const applyShutdownFilter = (type) => (value) => (dispatch) => {
  dispatch({
    type,
    payload: value,
  });

  dispatch(setChangedShutdownFilter(true));
  dispatch(setChosenShutdownFilter({ id: null, name: null }));
};

export const setShutdownFilterValues = (payload) => ({
  type: SET_SHUTDOWN_FILTER_VALUES,
  payload,
});

export const resetShutdownFilterValues = () => ({
  type: RESET_SHUTDOWN_FILTER_VALUES,
});

export const setShutdownFilterSearchValue = (payload) => ({
  type: SET_SEARCH_VALUE_SHUTDOWN_FILTER,
  payload,
});

export const setValueNewShutdown = (payload) => ({
  type: SET_VALUE_NEW_SHUTDOWN,
  payload,
});
